import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';

import { SuiContainer } from '@splashthat/sui';

import { NODE_TYPE_QUESTION, NODE_TYPE_CONTENT } from 'common/entities/formNode/nodeTypes';
import { getFormId, getFormIsSaving, getEditFormNode, isAllowedLogicNode } from '../../selectors';
import {
    saveEditFormNode,
    addQuestionToFormTemplateLibrary,
    openEditFormNodeLogic,
    updateFormNode,
} from '../../actions';
import { removeFormNode } from '../../actions/nodeActions';
import { SAVE_LOCKED_NODE_NAMES, DELETE_LOCKED_NODE_NAMES } from '../../constants/nodeNameRules';

import FormEditorEditContent from '../EditView/FormEditorEditContent';
import EditViewFooter from '../EditView/EditViewFooter';
import EditViewHeader from './EditViewHeader';
import { filterMarkup } from '../../utils/filterMarkupHelper';

const BASE_CLASS_NAME = 'EditFormNodePanel';

class EditFormNodePanel extends Component {
    static propTypes = {
        editFormNode: PropTypes.object,
        saveEditFormNode: PropTypes.func.isRequired,
        removeFormNode: PropTypes.func.isRequired,
        addQuestionToFormTemplateLibrary: PropTypes.func.isRequired,
        openEditFormNodeLogic: PropTypes.func.isRequired,
        isAllowedLogicNode: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        editFormNode: null,
        errors: [],
    };

    deleteEditFormNode = () => {
        const { editFormNode } = this.props;
        this.props.removeFormNode(editFormNode.id);
    };

    getHeaderLabel = () => {
        if (this.props.editFormNode.type === NODE_TYPE_CONTENT) {
            return filterMarkup(this.props.editFormNode.description);
        }
        return this.props.editFormNode.label || '';
    };

    openEditLogic = () => {
        this.props.openEditFormNodeLogic(this.props.editFormNode.id);
    };

    /**
     * Adds the question configuration to the bank.
     * @return {Promise}
     */
    addQuestionToFormTemplateLibrary = (newLabel) => {
        const { editFormNode } = this.props;
        return this.props.addQuestionToFormTemplateLibrary(editFormNode.id, newLabel);
    };

    getCanSaveNode() {
        return (
            !!this.props.editFormNode &&
            this.props.editFormNode.type === NODE_TYPE_QUESTION &&
            !SAVE_LOCKED_NODE_NAMES.find((name) => name === this.props.editFormNode.name)
        );
    }

    getCanDeleteNode() {
        return (
            !!this.props.editFormNode && !DELETE_LOCKED_NODE_NAMES.find((name) => name === this.props.editFormNode.name)
        );
    }

    render() {
        const { editFormNode } = this.props;

        const headerLabel = editFormNode && this.getHeaderLabel();
        return (
            <SuiContainer variation="flex-vertical" className={BASE_CLASS_NAME}>
                <EditViewHeader
                    label={headerLabel}
                    saveEditFormNode={this.props.saveEditFormNode}
                    locked={get(editFormNode, 'lock', 0) !== 0}
                />

                <SuiContainer className={`${BASE_CLASS_NAME}__content-container`}>
                    <FormEditorEditContent
                        formNodeType={get(editFormNode, 'type')}
                        formNodeName={get(editFormNode, 'name')}
                        formNodeInputType={get(editFormNode, 'inputType')}
                    />
                </SuiContainer>

                <EditViewFooter
                    onClickEditLogic={this.props.isAllowedLogicNode ? this.openEditLogic : null}
                    onClickSaveNode={this.getCanSaveNode() ? this.addQuestionToFormTemplateLibrary : null}
                    onClickDelete={this.getCanDeleteNode() ? this.deleteEditFormNode : null}
                    nodeType={get(editFormNode, 'type')}
                />
            </SuiContainer>
        );
    }
}

const mapStateToProps = (state) => {
    const editFormNode = getEditFormNode(state);
    const formId = getFormId(state);
    const isSaving = getFormIsSaving(state, formId);

    return {
        editFormNode,
        isSaving,
        isAllowedLogicNode: isAllowedLogicNode(state, editFormNode),
    };
};

const mapDispatchToProps = {
    saveEditFormNode,
    updateFormNode,
    removeFormNode,
    addQuestionToFormTemplateLibrary,
    openEditFormNodeLogic,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditFormNodePanel);
